<template>
    <div>
        <el-alert
            v-if="disabled"
            class="warning-message"
            title="Tous les champs et sélecteur de fichier sont requis"
            type="info"
            :closable="false"
            center
        >
        </el-alert>
        <el-upload
            drag
            ref="upload"
            class="upload-demo"
            accept=".csv"
            action=""
            :before-upload="handleChange"
            required
        >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
                Glisser un fichier ici ou cliquer pour charger
            </div>
            <div
                slot="tip"
                class="el-upload__tip"
            >
                Type de fichier supporté : csv
            </div>
        </el-upload>
        <div
            ref="graph"
            id="graph"
        ></div>
        <div v-if="plotting_in_progress">
            <p class="waiting">
                Veuillez attendre que les données soient chargées
            </p>
        </div>
        <div
            v-if="uploadedFile && !plotting_in_progress"
            class="rangeSelector"
        >
            <span>
                Date de début - Date de fin
            </span>
            <el-date-picker
                v-model="range"
                @change="changeGraphRange"
                type="datetimerange"
                start-placeholder="Date de départ"
                end-placeholder="Date de fin"
                range-separator="À"
                class="datetime"
            >
            </el-date-picker>
        </div>
        <div class="dialogButtons">
            <el-button
                class="whiteButton"
                :disabled="loadings.save"
                @click="closeModal"
            >
                Annuler
            </el-button>
            <el-tooltip
                popper-class="simulationCreationTooltip"
                :visible-arrow="false"
                :disabled="!disabled"
                :content="getContentForTooltip"
                placement="top"
                effect="dark"
            >
                <div>
                    <el-button
                        v-loading="loadings.save"
                        @click="saveRange"
                        :disabled="disabled || loadings.save"
                    >
                        Enregistrer
                    </el-button>
                </div>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import Plotly from 'plotly.js-basic-dist';
const MEASURE_FILE_VIVECO_MANUEL_FORMAT = 'viveco-manuel';
const MEASURE_FILE_MOTORBOX_V2_FORMAT = 'motorbox-v2';
const MEASURE_FILE_MOTORBOX_FLUKE_EN_FORMAT = 'motorbox-fluke-en';
const MEASURE_FILE_MOTORBOX_FLUKE_FR_FORMAT = 'motorbox-fluke-fr';
const LITERAL_MONTHS_MAP = {
  // TODO check the format
    'janv.': '1',
    'févr.': '2',
    'mars': '3',
    'avr.': '4',
    'mai': '5',
    'juin': '6',
    'juil.': '7',
    'août': '8',
    'sept.': '9',
    'oct.': '10',
    'nov.': '11',
    'déc.': '12',
};


var MEASURE_FILE_SUPPORTED_FORMATS = {
    [MEASURE_FILE_VIVECO_MANUEL_FORMAT]: {
        offset: 0,
        matchPattern: 'ANNEE;MOIS;JOUR;HEURE;MIN;SEC;Moyenne(V);',
        parsePattern: [
            new RegExp('^(?<year>\\d{4});(?<month>\\d+);(?<day>\\d+);(?<hour>\\d+);(?<minute>\\d+);(?<second>\\d+);(?<value>[\\d.,]+);')
        ],
    },
    [MEASURE_FILE_MOTORBOX_V2_FORMAT]: {
        offset: 5,
        matchPattern: 'Date;Current;Power;TempC;TempB;VBat1;VBat2;VBat3;DACA;DACB;Vraw;VrawCorr;DACoutA;Cal.',
        parsePattern: [
            new RegExp('^(?<day>\\d+)/(?<month>\\d+)/(?<year>\\d{4}) (?<hour>\\d+):(?<minute>\\d+);(?<value>[\\d,.]+);'),
            new RegExp('^(?<hour>\\d+):(?<minute>\\d+):(?<second>\\d+)-(?<day>\\d+)/(?<month>\\d+)/(?<year>\\d{2});(?<value>[\\d,.]+);'),
        ],
    },
    [MEASURE_FILE_MOTORBOX_FLUKE_EN_FORMAT]: {
        offset: 7,
        matchPattern: 'Reading,L\'heure de démarrage,Duration,Max Time,maximal (A AC),Moy (A AC)',
        parsePattern: [
            // 1,2023-11-06 11:35:09,0:01:00,2023-11-06 11:35:12,58.3,57.9,2023-11-06 11:35:12,57.6,2023-11-06 11:36:09
            new RegExp('^(?<idx>\\d+),(?<year>\\d{4})\\-(?<month>\\d{2})\\-(?<day>\\d{2})\\s(?<hour>\\d+):(?<minute>\\d+):(?<second>\\d+),(?<duration>\\d+:\\d+:\\d+),(?<maxTime>\\d{4}\\-\\d{2}-\\d{2}\\s\\d{2}:\\d{2}:\\d{2}),(?<maxAc>[\\d.]+),(?<value>[\\d.]+),')
        ],
    },
    [MEASURE_FILE_MOTORBOX_FLUKE_FR_FORMAT]: {
        offset: 7,
        matchPattern: 'Relevé,Heure de démarrage,Durée,Temps maximal,Max(A AC),Moyenne(A AC)',
        parsePattern: [
            // 1,10 mai 2023 15:25:57,00:00:10,10 mai 2023 15:26:05,"51.4","51.3",10 mai 2023 15:25:57,"50.8",10 mai 2023 15:26:07
            new RegExp('^(?<idx>\\d+),(?<day>\\d+)\\s(?<month>[\\wéû\\.]+)\\s(?<year>\\d{4})\\s(?<hour>\\d+):(?<minute>\\d+):(?<second>\\d+),(?<duration>\\d+:\\d+:\\d+),(?<maxTime>\\d+\\s[\\wéû\\.]+\\s\\d{4}\\s\\d{2}:\\d{2}:\\d{2}),(?<maxAc>[\\d.]+),(?<value>[\\d.]+)')
        ],
    }

};
export default {

    name: 'SimulationView',

    props:{
        motor: {
            type: Object,
            required: true
        }
    },

    data () {
        return {
            loadings: {
                save: false,
                restore: false
            },
            simulationFileFormat: 'unknow',
            plotting_in_progress: false,
            uploadedFile: null,
            range: [],
            defaultRange: [],
        };
    },

    computed:{
        getContentForTooltip() {
            if (this.uploadedFile === null) {
                return 'Sélectionnez un fichier de données pour la simulation';
            }
            if (this.caliberIsMissing) {
                return 'Sélectionnez un calibre pour la simulation';
            }
        },
        disabled() {
            return (!this.uploadedFile || this.caliberIsMissing);
        },
        caliberIsNeeded(){
            return this.simulationFileFormat === MEASURE_FILE_VIVECO_MANUEL_FORMAT;
        },
    },

    methods:{
        async saveRange(){
            this.loadings.save = true;
            let formData = new FormData();
            formData.append('mesure_file', this.uploadedFile);

            this.$store.dispatch('patchItem', {
                item: {
                    simulation_status: 'PENDING',
                    uid: this.motor,
                    url: this.motor.url
                },
                model: 'motors',
            }).then(() => {
                this.$store.dispatch('createItem', {
                    item: {
                        motor_uid: this.motor.uid,
                        start_date: this.range[0],
                        end_date: this.range[1],
                        archived: false,
                        is_latest: false
                    },
                    url: this.$store.state.api.meta.listModels.simulations.url,
                    model: 'simulations',
                }).then((response) => {
                    this.$store.dispatch('patchItemFormData', {
                        item: formData,
                        url: response.url,
                        model: 'simulations',
                    }).then((res) => {
                        return this.watchModelStatus(res, 'COMPLETED', 'FAILED')
                        .then(()=>{
                            this.$notify({
                                type: 'success',
                                title: 'Succès'
                            });
                            this.loadings.save = false;
                            this.closeModal();
                            this.$emit('refresh-data');
                        }).catch(()=>{
                            this.loadings.save = false;
                            this.$notify({
                                type: 'error',
                                title: 'Erreur',
                                message: this.motor.verbose_status
                            });
                        });
                    }).catch(() => {
                        this.loadings.save = false;
                        this.$notify({
                            type: 'error',
                            title: 'Erreur'
                        });
                    });
                }).catch(() => {
                    this.loadings.save = false;
                    this.$notify({
                        type: 'error',
                        title: 'Erreur'
                    });
                });
            });
        },
        async watchModelStatus(itemToWatch, successStatus, failedStatus = null){
            return new Promise((resolve, reject) => {
                let item = itemToWatch;
                let interval = setInterval(async ()=>{
                    if(item.status === successStatus){
                        resolve(item);
                        clearInterval(interval);
                    }
                    if(failedStatus !== null && item.status === failedStatus){
                        reject();
                        clearInterval(interval);
                    }
                    this.$store.dispatch('remoteGet', { url : itemToWatch.url })
                    .then(response =>{
                        item = response.data;
                    });
                }, 3000);
            });
        },
        closeModal(){
            this.$set(this, 'simulationFileFormat', 'unknow');
            this.$set(this, 'plotting_in_progress', false);
            this.$set(this, 'uploadedFile', null);
            this.$set(this, 'range', []);
            this.$set(this, 'defaultRange', []);
            this.$emit('close-simulation-modal');
        },
        changeGraphRange(rangeArray) {
            if (rangeArray) {
                this.$set(this, 'range', rangeArray);
                Plotly.relayout('graph', 'xaxis.range',[moment(rangeArray[0]).format('YYYY-MM-DDTHH:mm:ssZ'), moment(rangeArray[1]).format('YYYY-MM-DDTHH:mm:ssZ')]);
            }
            else {
                Plotly.relayout('graph', 'xaxis.autorange', true);

            }
        },
        handleChange(file) {
            this.loadFileAndDrawGraph(file);
            // Prevent file uploading
            return false;
        },
        async getTextFromFile (file){
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onabort = reject;
                reader.onerror = reject;
                reader.readAsText(file);
            });
        },
        getMeasureFileFormat(fileContentLines){
            // Info there :
            // https://git.netsach.info/edf/viveco/support/-/wikis/format-fichier-mesure
            for (const formatName in MEASURE_FILE_SUPPORTED_FORMATS) {
                let format = MEASURE_FILE_SUPPORTED_FORMATS[formatName];
                if(fileContentLines[format.offset] && fileContentLines[format.offset].startsWith(format.matchPattern)){
                    return formatName;
                }
            }
            // Unsupported format
            throw new Error('Unsupported measure file format');
        },
        makePlotly(x, y) {
            let traces = [{
                x: x,
                y: y
            }];
            // Use annotations because yaxis.title cannot be rotated
            let layout = {
                annotations: [{
                    xref: 'paper',
                    yref: 'paper',
                    x: 0,
                    xanchor: 'right',
                    y: 1,
                    yanchor: 'bottom',
                    text: '(A)',
                    showarrow: false
                }]
            };
            if (this.caliberIsNeeded) {
                layout.annotations[0].text = "(mV)";
            }
            Plotly.newPlot('graph', traces, layout).then(data => {
                this.$set(this, 'defaultRange', [data.layout.xaxis.range[0], data.layout.xaxis.range[1]]);
                this.$set(this, 'range', this.defaultRange);
            });
            this.plotting_in_progress = false;
            this.$refs.graph.on('plotly_relayout', (data) => {
                if (data['xaxis.range[0]'] && data['xaxis.range[1]']) { // when changes are thrown through the chart
                    this.$set(this, 'range', [data['xaxis.range[0]'], data['xaxis.range[1]']]);
                }
                else if (data['xaxis.range'] && data['xaxis.range'].length === 2) { // when changes are thrown through the datetime picker
                    this.$set(this, 'range', [data['xaxis.range'][0], data['xaxis.range'][1]]);
                }
                else { // when resetting to zoomed out value, or error
                    this.$set(this, 'range', this.defaultRange);
                }
            });
        },
        async loadFileAndDrawGraph(file){

            this.plotting_in_progress = true;
            this.uploadedFile = file;

            try{
                var fileContent = await this.getTextFromFile(file);
                // Clean file, remove BOM : <0xfeff>, 0xFEFF, uFEFF
                fileContent = fileContent.replace(/^\uFEFF/gm, '').replace(/^\u00BB\u00BF/gm,'').replace(/"/gm,'');
                let fileContentLines = fileContent.split(/\r?\n/);
                this.simulationFileFormat = this.getMeasureFileFormat(fileContentLines);

                let measureFileFormat = MEASURE_FILE_SUPPORTED_FORMATS[this.simulationFileFormat];

                // Use `splice` method here to avoid `slice` shallow copy
                fileContentLines.splice(0, measureFileFormat.offset + 1);
                let choosenPattern = null;
                let measures = fileContentLines.flatMap(line => {
                    if(line){
                        if (!choosenPattern){
                            // If the pattern is not set, try all the possible patterns
                            // on the first line, and choose the first that matches
                            measureFileFormat.parsePattern.forEach(pattern => {
                                let matches = line.match(pattern);
                                if(matches){
                                    choosenPattern = pattern;
                                }
                            });
                            if (!choosenPattern) {
                                console.log('line', line)
                                console.error('No match for following line');
                                throw new Error('Unsupported measure file format');
                            }
                        }
                        let matches = line.match(choosenPattern);
                        if(matches){
                            return [matches.groups];
                        }
                        else{
                            console.log('line', line)
                            console.error('No match for following line');
                            throw new Error('Unsupported measure file format');
                        }
                    }
                    return [];
                });

                let x = [];
                let y = [];
                for (let measure of measures) {
                    let month = measure.month;
                    if (month in LITERAL_MONTHS_MAP){
                        month = LITERAL_MONTHS_MAP[month];
                    }
                    x.push(`${measure.year}-${month.padStart(2, '0')}-${measure.day.padStart(2, '0')}T${measure.hour.padStart(2, '0')}:${measure.minute.padStart(2, '0')}`);
                    y.push(measure.value);
                }
                this.makePlotly(x, y);
            }
            catch(e){
                console.error(e);
                this.$notify.error({
                    message: 'Il y a une erreur dans le formattage de ce fichier, veuillez réessayer'
                });
            }
        },
    }
};
</script>

<style lang="scss">

.simulationCreationTooltip {
    font-size: 13px;
}
.wrapper {
    display: flex;
    width: 100%;
    flex-wrap: nowrap;
    height: auto;
    .button-wrapper {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        .title {
            width : 100%;
            margin-bottom: 40px;
        }
    }
    .no-mode-translate-fade-enter-active, .no-mode-translate-fade-leave-active {
        transition: all 0.5s;
    }
    .no-mode-translate-fade-enter, .no-mode-translate-fade-leave-active {
        opacity: 0;
    }
    .no-mode-translate-fade-enter {
        transform: translateX(31px);
    }
    .no-mode-translate-fade-leave-active {
        transform: translateX(-31px);
    }
    .factories, .motors {
        margin: 0 auto 30px;
    }
}

.upload-demo .el-upload input[type="file"]{
    display: none;
}

.researchField {
    margin-top: 20px;
    input {
        border-top: none;
        border-left: none;
        border-right: none;
        border-radius: 0;
        transition-duration: 0.4s;
        &:focus {
            border-bottom-width: 2px !important;
        }
    }
}

.cardButton {
    margin: auto !important;
    width: 100%;
    font-size: 14px;
    text-transform: uppercase;
    &.modalButton {
        margin-top: 10px !important;
    }
    &.error-modal-button {
        i {
            margin-right: 5px;
        }
    }
}
.notCancelled {
    margin-top: 40px !important;
}

.dialog {
    .warning-message {
        margin-bottom: 10px;
        background-color: #f7fbcf;
    }
}

.el-dialog__body {
    text-align: center !important;
    .el-upload__tip {
        margin-bottom: 20px;
    }
    .el-upload-dragger:hover {
    }
    .icon {
        margin-top: 55px;
        .icon-minus {
            font-size: 27px;
        }
        .icon-plus {
            font-size: 27px;
        }
    }
    .spaceTop {
        margin-top: 40px;
    }
}

.waiting {
    text-align: center;
    width: 60%;
    margin: 40px auto;
    font-size: 15px;
}
.dialogButtons{
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    margin-top: 3rem;
}
.rangeSelector{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 2rem;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Home/motors/simulations/Index.vue